import { render, staticRenderFns } from "./old.vue?vue&type=template&id=2f458c84"
import script from "./old.vue?vue&type=script&lang=js"
export * from "./old.vue?vue&type=script&lang=js"
import style0 from "./old.vue?vue&type=style&index=0&id=2f458c84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports